<div class="add-payment">

    <div class="ui-g-12 p-zero dialog-header">
        <span>Select your AL View</span>
        <i class="fal fa-times fa-sm dialog-close" (click)="closeModal()"></i>
    </div>

    <div class="dialog-body row">
        <div *ngIf="userInfo" class="corporate-dashboard mt-2 mx-4">

            <div class="ui-g ml-12">
                <!-- <div class="corporate-dashboard-title">
                    <span>Corporate dashboard</span>
                </div> -->

                <!-- <div class="dashboard">
                    <div class="corporate-dashboard-default ui-g-12">
                        <div class="ui-g-9 flex-start-center">
                            <app-radio-button name="cost" [label]="userInfo.corporate?.name"
                                [value]="userInfo.corporate?._id" [selectedValue]="userInfo.corporate?._id"
                                (appChange)="onChangeCorporate($event)"> </app-radio-button>
                        </div> -->
                        <!-- <div class="ui-g-3 flex-center-center">
                            <span
                                [ngClass]="userInfo.corporate?.default ? 'default-tag' : 'company-default-tag pointer'"
                                (click)="!userInfo.corporate?.default ? setDefaultView('corporate', userInfo.corporate):''">
                                {{userInfo.corporate?.default ? 'Default' : 'Make default'}}</span>
                        </div> -->
                    <!-- </div>
                </div> -->
                <button class="btn btn-primary btn-submit switch-view-btn" (click)="onChangeCorporate(userInfo.corporate?._id)"><i class="fas fa-repeat-alt pr-2"></i>
                    {{isMarkPsDashboard ? 'Launch Corporate Dashboard' : 'Switch to Corporate Dashboard'}}
                </button>
            </div>
            

            <div class="ui-g">
                <div class="locations-environment-title">
                    <span>Locations environment</span>
                </div>

                <div class="locations">
                    <div class="ui-g-12">
                        <div class="flex-start-center">
                            <app-auto-complete class="locations-suggestion" placeholder="Search locations"
                                theme="border" id="review-search-customer" leftIcon="fal fa-search" scrollHeight="192px"
                                listId="review-search-customer-list" [fontSize]="13" [autoFocus]="true"
                                [suggestions]="customerSearchResults" [closeOnSelection]="true" [value]=""
                                [hasSearchIcon]="true">
                                <!-- <ng-template let-item appTemplate="item">
                        <span class="search-item" [ngClass]="{'disabled': !item?.isActive}"
                          (click)="!item?.isActive? $event.stopPropagation() : null">
                          <div class="data-box" [ngClass]="{'disabled': !item?.isActive}">
                            <b>{{item.fullNameQBO}}</b>
                            <br>
                            {{item.phone | mask: '(000) 000-0000'}} {{ (item.email && item.phone) ? '-' : ''}}
                            {{item.email}}
                          </div>
                        </span>
                      </ng-template> -->
                            </app-auto-complete>
                        </div>
                    </div>
                </div>
            </div>

            <div class="company-info-cards mb-2">
                <div class="company-location" *ngFor="let company of userInfo?.companies">
                    <div class="ui-g">
                        <div class="dashboard-heading mb-2">
                            <span class="company-title">{{company.name}}</span>
                        </div>

                        <div class="dashboard mt-0" *ngFor="let shop of company.shops">
                            <div class="company-default py-0 ui-g-12">
                                <div class="ui-g-9 flex-start-center">
                                    <app-radio-button [label]="shop.name" [value]="shop._id"
                                        [selectedValue]="selectedShop" (appChange)="onChangeCompany($event, company)">
                                    </app-radio-button>
                                </div>
                                <!-- <div class="ui-g-3 flex-center-center">
                                    <span [ngClass]="shop.default ? 'default-tag' : 'company-default-tag pointer'"
                                        (click)="!shop.default ? setDefaultView('company', shop, company) : ''">
                                        {{shop.default ? 'Default' : 'Make default'}}</span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="dialog-footer flex-end-center">
        <button class="btn btn-white btn-border pointer btn-submit mr-1" (click)="closeModal()">Cancel</button>
        <button id="payment-btn-save" class="btn btn-primary btn-submit" [disabled]="false" (click)="onSubmit()">
            <span [ngClass]="">Save</span>
            <!-- <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i> -->
        </button>
    </div>
</div>